
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { truncate } from 'fs';
import { MessaggioNotifica, TipoMessaggioNotifica, Utente } from '@/models';
import { store, StoreMutations, ApplicationState, StoreActions } from '@/store';
import { InfoUtente } from '@/components';
import { config } from '@/infrastructure';

@Component({
  components: {
    InfoUtente
  },
})
export default class App extends Vue {

  //#region DATA
  private drawer: boolean = false;
  private items: any[] = [];
  //#endregion DATA

  get clientVersion() { return config.clientVersion; }

get loading() {
    return store.state.loading;
  }

  private splash = true;

  get dark() {
    return this.$vuetify.theme.dark;
  }

  set dark(value) {
    this.$vuetify.theme.dark = value;
  }

  get print() {
    return this.$route.name == 'ddt';
  }

  get titolo() {
    return store.state.ui.titoloPagina;
  }

  get sottotitolo() {
    return store.state.ui.sottotitoloPagina;
  }

  get opzioniVisibili() {
    return store.state.ui.opzioniVisibili;
  }

  set opzioniVisibili(visibile: boolean) {
    store.commit(StoreMutations.SetOpzioniVisibili, visibile);
  }

  get azioniVisibili() {
    return store.state.ui.azioniVisibili;
  }

  set azioniVisibili(visibile: boolean) {
    store.commit(StoreMutations.SetAzioniVisibili, visibile);
  }

  get user() {
    return store.state.currentUsr;
  }

  get userIsAdmin() {
    return this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined;
  }

  get noNetwork() {
    return store.state.appState == ApplicationState.NetworkError || store.state.appState == ApplicationState.FatalError;
  }

  get errori () {
    return store.state.errori.filter(err => err.showed === false);
  }

  segnaMessaggiLetti() {
    store.commit(StoreMutations.SetMessaggiVisti, TipoMessaggioNotifica.Errore);
    store.commit(StoreMutations.SetMessaggiVisti, TipoMessaggioNotifica.Warning);
    store.commit(StoreMutations.SetMessaggiVisti, TipoMessaggioNotifica.Info);
  }

  @Watch("$store.state.currentUsr")
  async updateMenu(user: any, userOld: any) {

    if(this.user) {
      let menu: any[] = [{
          icon: 'home',
          title: 'Home',
          route: '/'
        }, {
          icon: 'inbox-multiple',//'bubble_chart',
          title: 'Ordini',
          route: '/ordini'
        }, {
          icon: 'inbox-multiple-outline',//'bubble_chart',
          title: 'Ordini MTM',
          route: '/ordini-mtm'
        }, {
          icon: 'clipboard-text', //'local_offer', //'style',
          title: 'Righe / Consegne',
          route: '/righe'
        },
        // {
        //   icon: 'truck-delivery',// assignment
        //   title: 'Crea spedizione',
        //   route: '/spedisci'
        // },
        {
          icon: 'truck',
          title: 'Spedizioni',
          route: '/spedizioni'
        }, {
          icon: 'scissors-cutting', //'content-cut', // 'box-cutter', // circle-slice-7
          title: 'Consumi',
          route: '/consumi'
        }, {
          icon: 'clipboard-file', //'content-cut', // 'box-cutter', // circle-slice-7
          title: 'Reintegri',
          route: '/reintegri'
        }, {
          icon: 'cart',
          title: 'Dati venduto',
          route: '/venduto'
        }, {
          icon: 'information',
          title: 'Informazioni',
          route: '/about'
        }
      ];


      if(this.userIsAdmin) {
        //menu.splice(5, 0, adminOnlyItem);
      }
      else {
        //menu.push();
      }

      this.items = menu;

    } else {
      this.items = [];
      this.$router.push('/login');
    }
  }

  constructor() {
    super();
  }

  async mounted() {
    if(!this.user) {
      var loggedin = await store.dispatch(StoreActions.RefreshUser);

      if(!loggedin) {
        //this.logout();
      }
    }

    this.updateMenu(this.user, null);

    this.splash = false;
  }

  async logout() {
    await store.dispatch(StoreActions.Logout);
    this.$router.push('/login');
  };

  mapTipoMessaggio(msg: any) {
    if(msg.tipo === TipoMessaggioNotifica.Errore) {
      return 'error';
    } else if(msg.tipo === TipoMessaggioNotifica.Warning) {
      return 'warning';
    } else if(msg.tipo === TipoMessaggioNotifica.Info) {
      return 'info';
    }
  };
}
